import { any } from '@amcharts/amcharts5/.internal/core/util/Array';
import { CommonModule, DatePipe } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/module.d-CnjH8Dlt';
import { Component, OnInit, ViewChild } from '@angular/core';
import { AbstractControl, FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { DateAdapter, MAT_DATE_FORMATS, MAT_NATIVE_DATE_FORMATS } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialog } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { Router, RouterModule } from '@angular/router';
import { TablerIconsModule } from 'angular-tabler-icons';
import { PdfJsViewerComponent, PdfJsViewerModule } from 'ng2-pdfjs-viewer';
import { Editor, NgxEditorComponent, Toolbar, NgxEditorMenuComponent } from 'ngx-editor';
import { TRUE } from 'sass';
import Swal from 'sweetalert2';
import { BaseEntityModel } from '../../../Data/Models/Common/base-entity-model';
import { SoFAModal } from '../../../Data/Models/Common/SoFA-Model';
import { Email_Configuration_Model } from '../../../Data/Models/Email_Configuration_Model/Email_Configuration_Model';
import { RolesModel } from '../../../Data/Models/Users/roles-model';
import { MaterialModule } from '../../../material.module';
import { UsermanagementService } from '../../../services/apps/usermanagement/usermanagement.service';
import { Email_Configuration_Service } from '../../../services/Email_Configuration_Service/Email_Configuration_Service';
import { MessageServiceService } from '../../../Shared/common/message-service.service';
import { CustomDateAdapter } from '../../../Shared/common/ng-date-parse-adapter';
import { BalanceSheetapiService } from '../balancesheet/balance-sheetapi.service';
import { CharityDetailsModal } from '../charities/addcharities/CharityDetailsModal';
import { CharitiesService } from '../charities/services/charities.service';
import { CharityDataShareServiceService } from '../charities/services/charity-data-share-service.service';
import { ReportsService } from '../reports/reports.service';
import { SubmissionsapiService } from '../submissions/submissionsapi.service';
import { TrailBalanceService } from '../trailbalance/trail-balance.service';
import { SofaService } from './sofa_services/sofa.service';


@Component({
  selector: 'app-financialstatements',
  imports: [TablerIconsModule, MaterialModule, CommonModule, MatDatepickerModule, RouterModule, CommonModule, FormsModule, ReactiveFormsModule, PdfJsViewerModule, NgxEditorComponent, NgxEditorMenuComponent,],
  templateUrl: './financialstatements.component.html',
  styleUrl: './financialstatements.component.scss'
})
export class FinancialstatementsComponent implements OnInit {
  PeriodID: any;
  charityId: any;
  editor1: Editor;
  UserId: any;
  CentralUser: any;
  StatementofFinancialActivitiesForm: FormGroup;
  fieldValue: any;
  previousUnrestrictedFundsValue: number = 0;
  computedValue: any;
  previousRestricteIncomeValue: number = 0;
  previousEndowmentFundsValue: number = 0;
  preUnrestrictedTotalFundsValue: number = 0;
  preRestricteTotalFundsValue: number = 0;
  preTransfersBetweenValue: number = 0;
  preUnrestrictedBroughtForwardValue: number = 0;
  preRestricteIncomeBroughtForwardValue: number = 0;
  preEndowmentFundsBroughtForwardValue: number = 0;
  saveAsDraft: boolean = false;
  ShowSpinner2: any = false;
  isFundTracking: string | null;
  showAgeColumn: boolean = true;
  displayedColumns2: string[] = ['activity_Name', 'sofa_NotesID', 'unrestrictedFunds', 'restricteIncome', 'endowmentFunds', 'total_Funds', 'prior_Year_Funds'];
    firstAccPeriod: string | null;
  dataChanged: boolean = false;
  FinancialYear: any
  isFirstTime: boolean = false;
  showSaveBtn: boolean = false;
    Flag: any;
    ShowSpinner: boolean;
    pdfFile: string;
  Downloadreportname: string;
  SOFAform: FormGroup;
  UserRoleAccess: RolesModel
  @ViewChild('pdfViewerAutoLoad', { static: false }) pdfViewerAutoLoad: PdfJsViewerComponent
    emailConfigFormGroup: Email_Configuration_Model[]=[];
    RetriveEmailConfigdata: any;
  Base64orHTML: any;
  ispreview: boolean = false;
    BasicInformation: any=[];
  CurrentUserName: string;
  apFinalised: boolean = false
  SubmissionStatus: any;
  constructor(private SoFaService: SofaService, private Submissionsapiservice: SubmissionsapiService, private trailBalanceService: TrailBalanceService, private dataShareService: CharityDataShareServiceService, private apiservice: BalanceSheetapiService, public Charities_Service: CharitiesService, private fb: FormBuilder, private router: Router, private msgService: MessageServiceService, private reportservice: ReportsService, public dialog: MatDialog, private emailConfigService: Email_Configuration_Service, private _UsermanagementService: UsermanagementService, private sharedService: CharityDataShareServiceService)
  {
    //this.Getbasicinformation()
    debugger
  }
  isTrailBalancesaved() {
    this.trailBalanceService.isTrailBalancesaved(localStorage.getItem('currentPeriod')).subscribe((Response: any) => {
      this.ispreview = Response
    })
  }
  ngOnInit() {
    debugger
    this.isTrailBalancesaved()
    this.CreateCheckboxform();
    this.editor1 = new Editor();
    this.isFundTracking = localStorage.getItem('fund_Tracking')
    this.FinancialYear = localStorage.getItem('FY_Year')
    this.getSOFAdata()
    this.toggleAgeColumn()
    this.createSOFATemplate();
    this.GetUserAccess()
/*    this.Getcharitydetails();*/
    var parsedUser1: any = localStorage.getItem('currentUser');
    const parsedUser = JSON.parse(parsedUser1);
    this.CurrentUserName = `${parsedUser.firstName} ${parsedUser.lastName}`;
    //this.dataShareService.finalStatus$.subscribe((value: any) => {
    //  this.apFinalised = value != '' && value == 'Completed'
    //})
    this.SubmissionStatus = localStorage.getItem('SubmissionStatus');
  }
  createSOFATemplate() {
    this.SOFAform = this.fb.group({
      emailTemplateId: [0],
      emailType: ['SOFA'],
      from: [{ value: this.RetriveEmailConfigdata?.senderEmail, disabled: true }],
      //cc: ['', [Validators.pattern(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/)]],
      //bcc: ['', [Validators.pattern(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/)]],
      //pattern to allow multiple emails.
      cc: ['', [Validators.pattern(/^([a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[A-Za-z]{2,})(;\s*[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[A-Za-z]{2,})*$/)]],
      bcc: ['', [Validators.pattern(/^([a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[A-Za-z]{2,})(;\s*[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[A-Za-z]{2,})*$/)]],

      ccCheckbox: [false],
      subject: ['', Validators.required],
      Body: [''],
      charityName: [''],
      charityID: [+localStorage.getItem('charityId')!],
      financialPeriodsID: [+localStorage.getItem('currentPeriod')!],
      createdby: [0],
      modifiedby: [0],
      centralUserId: [+localStorage.getItem('CentralUserId')!],
      userId: [+localStorage.getItem('CurrentuserID')!],
      fund_Tracking: [localStorage.getItem('fund_Tracking') === 'true'],
      //fund_Tracking:[+localStorage.getItem('fund_Tracking')!],
      to: [
        '',
        [Validators.required, Validators.pattern(/^([a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[A-Za-z]{2,})(;\s*[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[A-Za-z]{2,})*$/)]
      ],
    });
    this.ifCCorBCCSOFA = false;
    this.SOFAform.get('Body')?.valueChanges.subscribe(value => {

      const plainText = value?.replace(/<[^>]*>/g, '') || '';
      if (plainText.length > 2500) {
        const trimmedText = plainText.substring(0, 2500);
        const safeHtml = `<p>${trimmedText}</p>`;
        this.SOFAform.get('Body')?.setValue(safeHtml, { emitEvent: false });
      }
    });
  }
  CharityDetails: CharityDetailsModal[] = [];
  Getcharitydetails() {
    debugger
    let charityID = localStorage.getItem("CharityIdforSubmission")
    if (charityID) {
      this.Charities_Service.EditCharityDetails(charityID).subscribe((data: CharityDetailsModal[]) => {
        debugger
        this.CharityDetails = data
      })
    }
  }
  closeModalPreview() {
    this.dialog.closeAll();
  }
  toolbar: Toolbar = [
    ['bold', 'italic'],
    ['underline'],
    ['ordered_list', 'bullet_list'],
    [{ heading: ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'] }],
    ['text_color', 'background_color'],
    ['align_left', 'align_center', 'align_right', 'align_justify'],
  ];

  toggleAgeColumn() {
    debugger
    this.firstAccPeriod = localStorage.getItem('IsFirstAccountingPeriod')
    if (this.isFundTracking == 'false') {
      if (this.firstAccPeriod == 'true') {
        this.displayedColumns2 = ["activity_Name", "sofa_NotesID", 'total_Funds', 'prior_Year_Funds'];
      } else {
        this.displayedColumns2 = ["activity_Name", "sofa_NotesID", 'total_Funds'];
      }
    } else {
      if (this.firstAccPeriod == 'true') {
        this.displayedColumns2 = ['activity_Name', 'sofa_NotesID', 'unrestrictedFunds', 'restricteIncome', 'endowmentFunds', 'total_Funds', 'prior_Year_Funds'];
      } else {
        this.displayedColumns2 = ['activity_Name', 'sofa_NotesID', 'unrestrictedFunds', 'restricteIncome', 'endowmentFunds', 'total_Funds'];
      }
    }
   // this.showAgeColumn = !this.showAgeColumn;
  }

  transactions: any = new MatTableDataSource<any>([]);
  isDataRow = (index: number, row: any) => row.data_Type === 'data';
  isHeaderRow = (index: number, row: any) => row.data_Type === 'header';
  isSubHeaderRow = (index: number, row: any) => row.data_Type === 'subheader';
  isfooterrow = (index: number, row: any) => row.data_Type === 'footer';

  RetriveEmailConfig(emailtemplate?:any) {
    debugger
    var Central_UserId = parseInt(localStorage.getItem('CentralUserId') || '0');
    this.emailConfigService.RetriveEmailConfig(Central_UserId).subscribe((data: BaseEntityModel<Email_Configuration_Model>) => {
      if (data.status === 0) {
        if (data.message == "Successfully, retrieved email server info") {
          if (data.entity != null && data.entity.length > 0) {
            this.RetriveEmailConfigdata = data.entity[0];
            this.SOFAform.controls['from'].setValue(this.RetriveEmailConfigdata?.senderEmail)
            this.SOFAform.controls['to'].markAsUntouched()
            this.dialog.open(emailtemplate, {
              width: '50%', maxWidth: '100%', maxHeight: 'auto', height: 'auto', disableClose: true
            });
            this.GetSOFAEmailTemplate()
          } else {
            Swal.fire({
              html: '<h5 class="f-s-16 f-w-600 text-black" id="exampleModalLiveLabel">Mail Server details not configured!</h5> <p class= "f-s-14 p-0 m-y-5 f-w-400 text-black"  style="line-height:22px"> Please configure Mail Server setting to send an email.',
              iconHtml: '<span class="fa fa-exclamation rounded-icon"></span>',
              confirmButtonText: "OK",
              allowOutsideClick: false
            }).then((result) => {
              if (result.value) {
              } else {
                return
              }
            })
            //this.toastr.error(data.message);

          }
        } else {
        }
      } else {
        Swal.fire({
          html: '<h5 class="f-s-16 f-w-600 text-black" id="exampleModalLiveLabel">Mail Server details not configured!</h5> <p class= "f-s-14 p-0 m-y-5 f-w-400 text-black"  style="line-height:22px"> Please configure Mail Server setting to send an email.',
          iconHtml: '<span class="fa fa-exclamation rounded-icon"></span>',
          confirmButtonText: "OK",
          allowOutsideClick: false
        }).then((result) => {
          if (result.value) {
          } else {
            return
          }
        })
        //t//his.toastr.error(data.message);
      }
    }, (error: HttpErrorResponse) => {
      //this.toastr.error(error.statusText);
    })

  }
  GetUserAccess() {
    debugger
    this._UsermanagementService.GetUserRoleAccess(localStorage['userID']).subscribe(data => {
      debugger
      if (data.entity.length) {
        this.UserRoleAccess = data.entity[0]
        var submitedDate = this.UserRoleAccess.currentAPSubmitDate
      }
      this.dataShareService.finalStatus$.subscribe((value: any) => {
        this.apFinalised = value != '' && value == 'Completed'
      })
    });
  }
  GetSOFAEmailTemplate() {
    debugger;
    this.ShowSpinner2 = true;
    this.Charities_Service.GetEmailTemplate(this.SOFAform.controls['centralUserId'].value, this.SOFAform.controls['emailType'].value).subscribe({
      next: (data: any) => {
        debugger;
        this.ShowSpinner2 = false;
        if (data.entity != null && data.entity[0].emailTemplateId != null) {
          data.entity[0].body = data.entity[0].body.replace('[UserName]', this.CurrentUserName)

          data.entity[0].subject = data.entity[0].subject.replace('[CharityName]', localStorage.getItem('charity_Name'))
          data.entity[0].charityName = localStorage.getItem('charity_Name')
          data.entity[0].subject = data.entity[0].subject.replace('[CN]', localStorage.getItem('charity_Registration_Number'))
          data.entity[0].body = data.entity[0].body.replace('[CharityName]', localStorage.getItem('charity_Name'))
          data.entity[0].body = data.entity[0].body.replace('[CN]', localStorage.getItem('charity_Registration_Number'))
          this.SOFAform.patchValue(data.entity[0])
          this.SOFAform.controls['Body'].setValue(data.entity[0].body)
          this.SOFAform.controls['charityID'].setValue(+localStorage.getItem('charityId')!)
          this.SOFAform.controls['financialPeriodsID'].setValue(+localStorage.getItem('currentPeriod')!)
          this.SOFAform.controls['fund_Tracking'].setValue(localStorage.getItem('fund_Tracking') === 'true')
          this.ifCCorBCCSOFA = data.entity[0].ccCheckbox;
        }
        else {
          this.createSOFATemplate()
        }
        this.SOFAform.markAsPristine()
        this.SOFAform.controls['from'].setValue(this.RetriveEmailConfigdata?.senderEmail)
      },
      error: (err) => {
        console.error('Error fetching GetSOFAEmailTemplate details:', err);
      }
    });
  }
  //createSoFAForm() {
  //  debugger
  //  this.StatementofFinancialActivitiesForm = new FormGroup({
  //    extrod_UnrestrictedFunds: new FormControl(null),
  //    extrod_RestrictedFunds: new FormControl(null),
  //    extrod_EndowmentFunds: new FormControl(null),
  //    trans_UnrestrictedFunds: new FormControl(null),
  //    trans_RestrictedFunds: new FormControl(null),
  //    trans_EndowmentFunds: new FormControl(null),
  //    total_UnrestrictedFunds: new FormControl(null),
  //    total_RestrictedFunds: new FormControl(null),
  //    total_EndowmentFunds: new FormControl(null)
  //  })
  //}

  disableNaviagtion() {
    document.body.classList.add('disable')
  }
  enableNavigation() {
    document.body.classList.remove('disable')
  }


  getSOFAdata() { 
    debugger
    this.disableNaviagtion();
    this.ShowSpinner2 = true;
    if (localStorage.getItem('currentCharityID') != null || localStorage.getItem('currentCharityID') != undefined || localStorage.getItem('currentCharityID') != '') {
      this.PeriodID = localStorage.getItem('currentPeriod')
      this.UserId = localStorage.getItem('userID')
      this.CentralUser = localStorage.getItem('CentralUserId')
      this.charityId = localStorage.getItem('currentCharityID')
    }
    if (localStorage.getItem('Charity_Type') === 'Unincorporated Charity') {
      debugger
      this.Flag = 'Fetch_Calculated_SofA_UnInCorporated';
    } else {
      this.Flag = 'Fetch_Calculated_SofA';
    }
    this.SoFaService.getStatementofFinancialActivities(this.Flag, this.PeriodID, this.UserId, this.CentralUser, this.charityId).subscribe((data: any) => {
      debugger
      this.ShowSpinner2 = false;
      this.enableNavigation();
      if (data.entity != null) {
        this.transactions = data.entity
        this.showSaveBtn = this.transactions[2].save_As_Draft
      }
    })
  }
  removeNotes(value: string): string {
    if (!value) return '';
    return value.replace(/\(Note.*?\)/g, '').trim();
  }

  computeSomething(val?:any): number {
    debugger
    this.computedValue = val;
    return this.computedValue;
  }

  unrestrictedFundsCalculation(accountName?: any, value?: any) {
    debugger
    this.dataChanged = true;
    if (accountName?.trim() === 'Extraordinary items') {
      if (localStorage.getItem('Charity_Type') === 'Unincorporated Charity') {
        debugger
        var extraordinaryItem = this.transactions.find(
          (t: any) => t.activity_Name?.trim() === 'Extraordinary items' && t.sofa_NotesID?.trim() === 'S16'
        );

        var netMovementItem = this.transactions.find(
          (t: any) => t.activity_Name?.trim() === 'Net movement in funds' && t.sofa_NotesID?.trim() === 'S20'
        );

        var totalFundsCarriedForwardItem = this.transactions.find(
          (t: any) => t.activity_Name?.trim() === 'Total funds carried forward' && t.sofa_NotesID?.trim() === 'S22'
        );
      } else {
        debugger
        var extraordinaryItem = this.transactions.find(
          (t: any) => t.activity_Name?.trim() === 'Extraordinary items' && t.sofa_NotesID?.trim() === 'S18'
        );

        var netMovementItem = this.transactions.find(
          (t: any) => t.activity_Name?.trim() === 'Net movement in funds' && t.sofa_NotesID?.trim() === 'S22'
        );

        var totalFundsCarriedForwardItem = this.transactions.find(
          (t: any) => t.activity_Name?.trim() === 'Total funds carried forward' && t.sofa_NotesID?.trim() === 'S24'
        );
      }
      if (extraordinaryItem && netMovementItem && totalFundsCarriedForwardItem) {
        const newValue = Number(value) || 0;

        // Update unrestrictedFunds
        netMovementItem.unrestrictedFunds = (netMovementItem.unrestrictedFunds || 0) - this.previousUnrestrictedFundsValue + newValue;
        totalFundsCarriedForwardItem.unrestrictedFunds = (totalFundsCarriedForwardItem.unrestrictedFunds || 0) - this.previousUnrestrictedFundsValue + newValue;

        // Update total_Funds in S18
        extraordinaryItem.total_Funds =
          (extraordinaryItem.unrestrictedFunds || 0) +
          (extraordinaryItem.restricteIncome || 0) +
          (extraordinaryItem.endowmentFunds || 0);

        // Update total_Funds in S22
        netMovementItem.total_Funds =
          (netMovementItem.unrestrictedFunds || 0) +
          (netMovementItem.restricteIncome || 0) +
          (netMovementItem.endowmentFunds || 0);

        // Update total_Funds in S24
        totalFundsCarriedForwardItem.total_Funds =
          (totalFundsCarriedForwardItem.unrestrictedFunds || 0) +
          (totalFundsCarriedForwardItem.restricteIncome || 0) +
          (totalFundsCarriedForwardItem.endowmentFunds || 0);

        // Store the new value
        this.previousUnrestrictedFundsValue = newValue;
      }
    }
    if (accountName?.trim() === 'Transfers between funds') {
      if (localStorage.getItem('Charity_Type') === 'Unincorporated Charity') {
        debugger
        var transfersBetweenFunds = this.transactions.find(
          (t: any) => t.activity_Name?.trim() === 'Transfers between funds' && t.sofa_NotesID?.trim() === 'S17'
        );

        var netMovementItem = this.transactions.find(
          (t: any) => t.activity_Name?.trim() === 'Net movement in funds' && t.sofa_NotesID?.trim() === 'S20'
        );

        var totalFundsCarriedForwardItem = this.transactions.find(
          (t: any) => t.activity_Name?.trim() === 'Total funds carried forward' && t.sofa_NotesID?.trim() === 'S22'
        );
      } else {
        debugger
        var transfersBetweenFunds = this.transactions.find(
          (t: any) => t.activity_Name?.trim() === 'Transfers between funds' && t.sofa_NotesID?.trim() === 'S19'
        );

        var netMovementItem = this.transactions.find(
          (t: any) => t.activity_Name?.trim() === 'Net movement in funds' && t.sofa_NotesID?.trim() === 'S22'
        );

        var totalFundsCarriedForwardItem = this.transactions.find(
          (t: any) => t.activity_Name?.trim() === 'Total funds carried forward' && t.sofa_NotesID?.trim() === 'S24'
        );
      }
      if (transfersBetweenFunds && netMovementItem && totalFundsCarriedForwardItem) {
        const newValue = Number(value) || 0;

        // Update restrictedFunds
        netMovementItem.unrestrictedFunds = (netMovementItem.unrestrictedFunds || 0) - this.preUnrestrictedTotalFundsValue + newValue;
        totalFundsCarriedForwardItem.unrestrictedFunds = (totalFundsCarriedForwardItem.unrestrictedFunds || 0) - this.preUnrestrictedTotalFundsValue + newValue;

        // Update total_Funds in S18
        transfersBetweenFunds.total_Funds =
          (transfersBetweenFunds.unrestrictedFunds || 0) +
          (transfersBetweenFunds.restricteIncome || 0) +
          (transfersBetweenFunds.endowmentFunds || 0);

        // Update total_Funds in S22
        netMovementItem.total_Funds =
          (netMovementItem.unrestrictedFunds || 0) +
          (netMovementItem.restricteIncome || 0) +
          (netMovementItem.endowmentFunds || 0);

        // Update total_Funds in S24
        totalFundsCarriedForwardItem.total_Funds =
          (totalFundsCarriedForwardItem.unrestrictedFunds || 0) +
          (totalFundsCarriedForwardItem.restricteIncome || 0) +
          (totalFundsCarriedForwardItem.endowmentFunds || 0);

        // Store the new value
        this.preUnrestrictedTotalFundsValue = newValue;
      }
    }
    if (accountName?.trim() === 'Total funds brought forward') {
      if (localStorage.getItem('Charity_Type') === 'Unincorporated Charity') {
        debugger
        var totalFundsBroughtForward = this.transactions.find(
          (t: any) => t.activity_Name?.trim() === 'Total funds brought forward' && t.sofa_NotesID?.trim() === 'S21'
        );

        var netMovementItem = this.transactions.find(
          (t: any) => t.activity_Name?.trim() === 'Net movement in funds' && t.sofa_NotesID?.trim() === 'S20'
        );

        var totalFundsCarriedForwardItem = this.transactions.find(
          (t: any) => t.activity_Name?.trim() === 'Total funds carried forward' && t.sofa_NotesID?.trim() === 'S22'
        );
      } else {
        debugger
        var totalFundsBroughtForward = this.transactions.find(
          (t: any) => t.activity_Name?.trim() === 'Total funds brought forward' && t.sofa_NotesID?.trim() === 'S23'
        );

        var netMovementItem = this.transactions.find(
          (t: any) => t.activity_Name?.trim() === 'Net movement in funds' && t.sofa_NotesID?.trim() === 'S22'
        );

        var totalFundsCarriedForwardItem = this.transactions.find(
          (t: any) => t.activity_Name?.trim() === 'Total funds carried forward' && t.sofa_NotesID?.trim() === 'S24'
        );
      }
      if (totalFundsBroughtForward && netMovementItem && totalFundsCarriedForwardItem) {
        const newValue = Number(value) || 0;

        // Update restrictedFunds
       // netMovementItem.unrestrictedFunds = (netMovementItem.unrestrictedFunds || 0) - this.preUnrestrictedBroughtForwardValue + newValue;
        totalFundsCarriedForwardItem.unrestrictedFunds = (totalFundsCarriedForwardItem.unrestrictedFunds || 0) - this.preUnrestrictedBroughtForwardValue + newValue;

        // Update total_Funds in S18
        totalFundsBroughtForward.total_Funds =
        (totalFundsBroughtForward.unrestrictedFunds || 0) +
        (totalFundsBroughtForward.restricteIncome || 0) +
        (totalFundsBroughtForward.endowmentFunds || 0);

        // Update total_Funds in S22
        netMovementItem.total_Funds =
          (netMovementItem.unrestrictedFunds || 0) +
          (netMovementItem.restricteIncome || 0) +
          (netMovementItem.endowmentFunds || 0);

        // Update total_Funds in S24
        totalFundsCarriedForwardItem.total_Funds =
          (totalFundsCarriedForwardItem.unrestrictedFunds || 0) +
          (totalFundsCarriedForwardItem.restricteIncome || 0) +
          (totalFundsCarriedForwardItem.endowmentFunds || 0);

        // Store the new value
        this.preUnrestrictedBroughtForwardValue = newValue;
      }
    }
  }
  restricteIncomeCalculation(accountName?: any, value?: any) {
    debugger
    this.dataChanged = true;
    if (accountName?.trim() === 'Extraordinary items') {
      if (localStorage.getItem('Charity_Type') === 'Unincorporated Charity') {
        debugger
        var extraordinaryItem = this.transactions.find(
          (t: any) => t.activity_Name?.trim() === 'Extraordinary items' && t.sofa_NotesID?.trim() === 'S16'
        );

        var netMovementItem = this.transactions.find(
          (t: any) => t.activity_Name?.trim() === 'Net movement in funds' && t.sofa_NotesID?.trim() === 'S20'
        );

        var totalFundsCarriedForwardItem = this.transactions.find(
          (t: any) => t.activity_Name?.trim() === 'Total funds carried forward' && t.sofa_NotesID?.trim() === 'S22'
        );
      } else {
        var extraordinaryItem = this.transactions.find(
          (t: any) => t.activity_Name?.trim() === 'Extraordinary items' && t.sofa_NotesID?.trim() === 'S18'
        );

        var netMovementItem = this.transactions.find(
          (t: any) => t.activity_Name?.trim() === 'Net movement in funds' && t.sofa_NotesID?.trim() === 'S22'
        );

        var totalFundsCarriedForwardItem = this.transactions.find(
          (t: any) => t.activity_Name?.trim() === 'Total funds carried forward' && t.sofa_NotesID?.trim() === 'S24'
        );
      }
   

      if (extraordinaryItem && netMovementItem && totalFundsCarriedForwardItem) {
        const newValue = Number(value) || 0;

        // Update restrictedFunds
        netMovementItem.restricteIncome = (netMovementItem.restricteIncome || 0) - this.previousRestricteIncomeValue + newValue;
        totalFundsCarriedForwardItem.restricteIncome = (totalFundsCarriedForwardItem.restricteIncome || 0) - this.previousRestricteIncomeValue + newValue;

        // Update total_Funds in S18
        extraordinaryItem.total_Funds =
          (extraordinaryItem.unrestrictedFunds || 0) +
          (extraordinaryItem.restricteIncome || 0) +
          (extraordinaryItem.endowmentFunds || 0);

        // Update total_Funds in S22
        netMovementItem.total_Funds =
          (netMovementItem.unrestrictedFunds || 0) +
          (netMovementItem.restricteIncome || 0) +
          (netMovementItem.endowmentFunds || 0);

        // Update total_Funds in S24
        totalFundsCarriedForwardItem.total_Funds =
          (totalFundsCarriedForwardItem.unrestrictedFunds || 0) +
          (totalFundsCarriedForwardItem.restricteIncome || 0) +
          (totalFundsCarriedForwardItem.endowmentFunds || 0);

        // Store the new value
        this.previousRestricteIncomeValue = newValue;
      }
    }
    if (accountName?.trim() === 'Transfers between funds') {
      if (localStorage.getItem('Charity_Type') === 'Unincorporated Charity') {
        debugger
        var transfersBetweenFunds = this.transactions.find(
          (t: any) => t.activity_Name?.trim() === 'Transfers between funds' && t.sofa_NotesID?.trim() === 'S17'
        );

        var netMovementItem = this.transactions.find(
          (t: any) => t.activity_Name?.trim() === 'Net movement in funds' && t.sofa_NotesID?.trim() === 'S20'
        );

        var totalFundsCarriedForwardItem = this.transactions.find(
          (t: any) => t.activity_Name?.trim() === 'Total funds carried forward' && t.sofa_NotesID?.trim() === 'S22'
        );
      }
      else {
        var transfersBetweenFunds = this.transactions.find(
          (t: any) => t.activity_Name?.trim() === 'Transfers between funds' && t.sofa_NotesID?.trim() === 'S19'
        );

        var netMovementItem = this.transactions.find(
          (t: any) => t.activity_Name?.trim() === 'Net movement in funds' && t.sofa_NotesID?.trim() === 'S22'
        );

        var totalFundsCarriedForwardItem = this.transactions.find(
          (t: any) => t.activity_Name?.trim() === 'Total funds carried forward' && t.sofa_NotesID?.trim() === 'S24'
        );
      }

      if (transfersBetweenFunds && netMovementItem && totalFundsCarriedForwardItem) {
        const newValue = Number(value) || 0;

        // Update restrictedFunds
        netMovementItem.restricteIncome = (netMovementItem.restricteIncome || 0) - this.preRestricteTotalFundsValue + newValue;
        totalFundsCarriedForwardItem.restricteIncome = (totalFundsCarriedForwardItem.restricteIncome || 0) - this.preRestricteTotalFundsValue + newValue;

        // Update total_Funds in S18
        transfersBetweenFunds.total_Funds =
          (transfersBetweenFunds.unrestrictedFunds || 0) +
          (transfersBetweenFunds.restricteIncome || 0) +
          (transfersBetweenFunds.endowmentFunds || 0);

        // Update total_Funds in S22
        netMovementItem.total_Funds =
          (netMovementItem.unrestrictedFunds || 0) +
          (netMovementItem.restricteIncome || 0) +
          (netMovementItem.endowmentFunds || 0);

        // Update total_Funds in S24
        totalFundsCarriedForwardItem.total_Funds =
          (totalFundsCarriedForwardItem.unrestrictedFunds || 0) +
          (totalFundsCarriedForwardItem.restricteIncome || 0) +
          (totalFundsCarriedForwardItem.endowmentFunds || 0);

        // Store the new value
        this.preRestricteTotalFundsValue = newValue;
      }
    }
    if (accountName?.trim() === 'Total funds brought forward') {
      if (localStorage.getItem('Charity_Type') === 'Unincorporated Charity') {
        debugger
        var totalFundsBroughtForward = this.transactions.find(
          (t: any) => t.activity_Name?.trim() === 'Total funds brought forward' && t.sofa_NotesID?.trim() === 'S21'
        );

        var netMovementItem = this.transactions.find(
          (t: any) => t.activity_Name?.trim() === 'Net movement in funds' && t.sofa_NotesID?.trim() === 'S20'
        );

        var totalFundsCarriedForwardItem = this.transactions.find(
          (t: any) => t.activity_Name?.trim() === 'Total funds carried forward' && t.sofa_NotesID?.trim() === 'S22'
        );
      }
      else {
        debugger
        var totalFundsBroughtForward = this.transactions.find(
          (t: any) => t.activity_Name?.trim() === 'Total funds brought forward' && t.sofa_NotesID?.trim() === 'S23'
        );

        var netMovementItem = this.transactions.find(
          (t: any) => t.activity_Name?.trim() === 'Net movement in funds' && t.sofa_NotesID?.trim() === 'S22'
        );

        var totalFundsCarriedForwardItem = this.transactions.find(
          (t: any) => t.activity_Name?.trim() === 'Total funds carried forward' && t.sofa_NotesID?.trim() === 'S24'
        );
      }
      if (totalFundsBroughtForward && netMovementItem && totalFundsCarriedForwardItem) {
        const newValue = Number(value) || 0;

        // Update restrictedFunds
        //netMovementItem.restricteIncome = (netMovementItem.restricteIncome || 0) - this.preRestricteIncomeBroughtForwardValue + newValue;
        totalFundsCarriedForwardItem.restricteIncome = (totalFundsCarriedForwardItem.restricteIncome || 0) - this.preRestricteIncomeBroughtForwardValue + newValue;

        // Update total_Funds in S18
        totalFundsBroughtForward.total_Funds =
          (totalFundsBroughtForward.unrestrictedFunds || 0) +
          (totalFundsBroughtForward.restricteIncome || 0) +
          (totalFundsBroughtForward.endowmentFunds || 0);

        // Update total_Funds in S22
        netMovementItem.total_Funds =
          (netMovementItem.unrestrictedFunds || 0) +
          (netMovementItem.restricteIncome || 0) +
          (netMovementItem.endowmentFunds || 0);

        // Update total_Funds in S24
        totalFundsCarriedForwardItem.total_Funds =
          (totalFundsCarriedForwardItem.unrestrictedFunds || 0) +
          (totalFundsCarriedForwardItem.restricteIncome || 0) +
          (totalFundsCarriedForwardItem.endowmentFunds || 0);

        // Store the new value
        this.preRestricteIncomeBroughtForwardValue = newValue;
      }
    }
  }
  endowmentFundsCalculation(accountName?: any, value?: any) {
    debugger
    this.dataChanged = true
    if (accountName?.trim() === 'Extraordinary items') {
      if (localStorage.getItem('Charity_Type') === 'Unincorporated Charity') {
        debugger
        var extraordinaryItem = this.transactions.find(
          (t: any) => t.activity_Name?.trim() === 'Extraordinary items' && t.sofa_NotesID?.trim() === 'S16'
        );

        var netMovementItem = this.transactions.find(
          (t: any) => t.activity_Name?.trim() === 'Net movement in funds' && t.sofa_NotesID?.trim() === 'S20'
        );

        var totalFundsCarriedForwardItem = this.transactions.find(
          (t: any) => t.activity_Name?.trim() === 'Total funds carried forward' && t.sofa_NotesID?.trim() === 'S22'
        );
      }
      else {
        var extraordinaryItem = this.transactions.find(
          (t: any) => t.activity_Name?.trim() === 'Extraordinary items' && t.sofa_NotesID?.trim() === 'S18'
        );

        var netMovementItem = this.transactions.find(
          (t: any) => t.activity_Name?.trim() === 'Net movement in funds' && t.sofa_NotesID?.trim() === 'S22'
        );

        var totalFundsCarriedForwardItem = this.transactions.find(
          (t: any) => t.activity_Name?.trim() === 'Total funds carried forward' && t.sofa_NotesID?.trim() === 'S24'
        );
      }

      if (extraordinaryItem && netMovementItem && totalFundsCarriedForwardItem) {
        const newValue = Number(value) || 0;

        // Update restrictedFunds
        netMovementItem.endowmentFunds = (netMovementItem.endowmentFunds || 0) - this.previousEndowmentFundsValue + newValue;
        totalFundsCarriedForwardItem.endowmentFunds = (totalFundsCarriedForwardItem.endowmentFunds || 0) - this.previousEndowmentFundsValue + newValue;

        // Update total_Funds in S18
        extraordinaryItem.total_Funds =
          (extraordinaryItem.unrestrictedFunds || 0) +
          (extraordinaryItem.restricteIncome || 0) +
          (extraordinaryItem.endowmentFunds || 0);

        // Update total_Funds in S22
        netMovementItem.total_Funds =
          (netMovementItem.unrestrictedFunds || 0) +
          (netMovementItem.restricteIncome || 0) +
          (netMovementItem.endowmentFunds || 0);

        // Update total_Funds in S24
        totalFundsCarriedForwardItem.total_Funds =
          (totalFundsCarriedForwardItem.unrestrictedFunds || 0) +
          (totalFundsCarriedForwardItem.restricteIncome || 0) +
          (totalFundsCarriedForwardItem.endowmentFunds || 0);

        // Store the new value
        this.previousEndowmentFundsValue = newValue;
      }
    }
    if (accountName?.trim() === 'Transfers between funds') {
      if (localStorage.getItem('Charity_Type') === 'Unincorporated Charity') {
        debugger
        var transfersBetweenFunds = this.transactions.find(
          (t: any) => t.activity_Name?.trim() === 'Transfers between funds' && t.sofa_NotesID?.trim() === 'S17'
        );

        var netMovementItem = this.transactions.find(
          (t: any) => t.activity_Name?.trim() === 'Net movement in funds' && t.sofa_NotesID?.trim() === 'S20'
        );

        var totalFundsCarriedForwardItem = this.transactions.find(
          (t: any) => t.activity_Name?.trim() === 'Total funds carried forward' && t.sofa_NotesID?.trim() === 'S22'
        );
      }
      else {
        var transfersBetweenFunds = this.transactions.find(
          (t: any) => t.activity_Name?.trim() === 'Transfers between funds' && t.sofa_NotesID?.trim() === 'S19'
        );

        var netMovementItem = this.transactions.find(
          (t: any) => t.activity_Name?.trim() === 'Net movement in funds' && t.sofa_NotesID?.trim() === 'S22'
        );

        var totalFundsCarriedForwardItem = this.transactions.find(
          (t: any) => t.activity_Name?.trim() === 'Total funds carried forward' && t.sofa_NotesID?.trim() === 'S24'
        );
      }
      if (transfersBetweenFunds && netMovementItem && totalFundsCarriedForwardItem) {
        const newValue = Number(value) || 0;

        // Update restrictedFunds
        netMovementItem.endowmentFunds = (netMovementItem.endowmentFunds || 0) - this.preTransfersBetweenValue + newValue;
        totalFundsCarriedForwardItem.endowmentFunds = (totalFundsCarriedForwardItem.endowmentFunds || 0) - this.preTransfersBetweenValue + newValue;

        // Update total_Funds in S18
        transfersBetweenFunds.total_Funds =
          (transfersBetweenFunds.unrestrictedFunds || 0) +
          (transfersBetweenFunds.restricteIncome || 0) +
          (transfersBetweenFunds.endowmentFunds || 0);

        // Update total_Funds in S22
        netMovementItem.total_Funds =
          (netMovementItem.unrestrictedFunds || 0) +
          (netMovementItem.restricteIncome || 0) +
          (netMovementItem.endowmentFunds || 0);

        // Update total_Funds in S24
        totalFundsCarriedForwardItem.total_Funds =
          (totalFundsCarriedForwardItem.unrestrictedFunds || 0) +
          (totalFundsCarriedForwardItem.restricteIncome || 0) +
          (totalFundsCarriedForwardItem.endowmentFunds || 0);

        // Store the new value
        this.preTransfersBetweenValue = newValue;
      }
    }
    if (accountName?.trim() === 'Total funds brought forward') {
      if (localStorage.getItem('Charity_Type') === 'Unincorporated Charity') {
        debugger
        var totalFundsBroughtForward = this.transactions.find(
          (t: any) => t.activity_Name?.trim() === 'Total funds brought forward' && t.sofa_NotesID?.trim() === 'S21'
        );

        var netMovementItem = this.transactions.find(
          (t: any) => t.activity_Name?.trim() === 'Net movement in funds' && t.sofa_NotesID?.trim() === 'S22'
        );

        var totalFundsCarriedForwardItem = this.transactions.find(
          (t: any) => t.activity_Name?.trim() === 'Total funds carried forward' && t.sofa_NotesID?.trim() === 'S22'
        );
      }
      else {
        var totalFundsBroughtForward = this.transactions.find(
          (t: any) => t.activity_Name?.trim() === 'Total funds brought forward' && t.sofa_NotesID?.trim() === 'S23'
        );

        var netMovementItem = this.transactions.find(
          (t: any) => t.activity_Name?.trim() === 'Net movement in funds' && t.sofa_NotesID?.trim() === 'S22'
        );

        var totalFundsCarriedForwardItem = this.transactions.find(
          (t: any) => t.activity_Name?.trim() === 'Total funds carried forward' && t.sofa_NotesID?.trim() === 'S24'
        );
      }
      if (totalFundsBroughtForward && netMovementItem && totalFundsCarriedForwardItem) {
        const newValue = Number(value) || 0;

        // Update restrictedFunds
       // netMovementItem.endowmentFunds = (netMovementItem.endowmentFunds || 0) - this.preEndowmentFundsBroughtForwardValue + newValue;
        totalFundsCarriedForwardItem.endowmentFunds = (totalFundsCarriedForwardItem.endowmentFunds || 0) - this.preEndowmentFundsBroughtForwardValue + newValue;

        // Update total_Funds in S18
        totalFundsBroughtForward.total_Funds =
          (totalFundsBroughtForward.unrestrictedFunds || 0) +
          (totalFundsBroughtForward.restricteIncome || 0) +
          (totalFundsBroughtForward.endowmentFunds || 0);

        // Update total_Funds in S22
        netMovementItem.total_Funds =
          (netMovementItem.unrestrictedFunds || 0) +
          (netMovementItem.restricteIncome || 0) +
          (netMovementItem.endowmentFunds || 0);

        // Update total_Funds in S24
        totalFundsCarriedForwardItem.total_Funds =
          (totalFundsCarriedForwardItem.unrestrictedFunds || 0) +
          (totalFundsCarriedForwardItem.restricteIncome || 0) +
          (totalFundsCarriedForwardItem.endowmentFunds || 0);

        // Store the new value
        this.preEndowmentFundsBroughtForwardValue = newValue;
      }
    }
  }


  formatFunds(value: number): string {
    return value < 0 ? `(${Math.abs(value)})` : value.toString();
  }

  SaveStatementOfActivities(isSaveasDraft?: any,value?:any) {
    debugger
    if (isSaveasDraft == 'true') {
      this.saveAsDraft = true;  
    } else {
      this.saveAsDraft = false;
      this.isFirstTime = true;
    }
    const CenUserId = localStorage.getItem('CentralUserId');
    const CharityId = localStorage.getItem('charityId');
    const UserID = localStorage.getItem('userID');
    const FinancialPeriodID = localStorage.getItem('currentPeriod');

    for (let i = 0; i < this.transactions.length; i++) {
      debugger
      this.transactions[i].centralUserId = +(CenUserId == null ? 0 : CenUserId);
      this.transactions[i].charityID = +(CharityId == null ? 0 : CharityId);
      this.transactions[i].userId = +(UserID == null ? 0 : UserID);
      this.transactions[i].FinancialPeriodsID = +(FinancialPeriodID == null ? 0 : FinancialPeriodID);
      this.transactions[i].save_As_Draft = this.saveAsDraft;
    }
    var modal = new SoFAModal();
    modal = this.transactions;

    this.SoFaService.SaveStatementOfActivities(modal).subscribe((data: any) => {
      debugger
      this.dataChanged = false;
     // if (data.entity != null) {
        if (this.saveAsDraft == true) {
          this.router.navigate(['balancesheet']);
        /*  if (value == 'Save') {
            this.msgService.showToastMessage("success", "Statement of Financial Activities (SoFA) saved successfully");
          } else {
            this.msgService.showToastMessage("success", "Statement of Financial Activities (SoFA) updated successfully");
          }*/
        } else {
          this.router.navigate(['charity']);
          /*this.msgService.showToastMessage("success", "Statement of Financial Activities (SoFA) has been saved as draft successfully");*/
        }
  //    }
    })
  }
  SoFABack() {
    debugger
    if (this.dataChanged == true) {
      Swal.fire({
        html: '<h5 class="f-s-16 f-w-600 text-black" id="exampleModalLiveLabel">Leave the page?</h5> <p class= "f-s-14 p-0 m-y-5 f-w-400 text-black"  style="line-height:22px"> Are you sure you want to leave this page. <br> Data entered will not be saved.</p>',
        iconHtml: '<span class="fa fa-exclamation rounded-icon"></span>',
        confirmButtonText: "Leave",
        showCancelButton: true,
        cancelButtonText: "Stay",
        allowOutsideClick: false,
        reverseButtons: true
      }).then((result) => {
        if (result.value) {
          this.router.navigate(['trialbalance'])
        } else {
          return
        }
      })
    } else {
      this.router.navigate(['trialbalance'])
    }
  }


  backToCharityOverView() {
    debugger
    // this.spinner.show()
    if (this.dataChanged == true) {
      Swal.fire({
        html: '<h5 class="f-s-16 f-w-600 text-black" id="exampleModalLiveLabel">Leave the page?</h5>' +
          '<p class="f-s-14 p-0 m-y-5 f-w-400 text-black" style="line-height:22px">' +
          'Are you sure you want to leave the page<br>Data entered will not be saved.</p>',
        iconHtml: '<span class="fa fa-exclamation rounded-icon"></span>',
        confirmButtonText: "Leave",
        showCancelButton: true,
        cancelButtonText: "Stay",
        allowOutsideClick: false,
        reverseButtons: true
      }).then((result) => {
        if (result.value) {
          localStorage.setItem('isFromBasicInfo', 'true')
          this.router.navigate(['/charity']);

        } else {
          return
        }
      });
    }
    else {
      localStorage.setItem('isFromBasicInfo', 'true')
      this.router.navigate(['/charity']);
    }
  }
  PreviewSOFA(template: any) {
    this.disableNaviagtion()
    this.ShowSpinner = true
    this.reportservice.GetSOFA(this.PeriodID, this.UserId, this.CentralUser, this.charityId, localStorage.getItem('fund_Tracking') == 'true' ? true : false).subscribe((data: any) => {
      const byteCharacters = atob(data.Item1.toString());
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], { type: 'application/pdf' });
        this.pdfFile = URL.createObjectURL(blob);

      this.Downloadreportname = "Statement of Financial Activities Report.pdf";
          this.dialog.open(template, {
            width: '50%', maxWidth: '100%', maxHeight: 'auto', height: 'auto', disableClose: true
          });
          setTimeout(() => {
            if (this.pdfViewerAutoLoad) {
              this.pdfViewerAutoLoad.pdfSrc = this.pdfFile;
              this.pdfViewerAutoLoad.downloadFileName = this.Downloadreportname;
              this.pdfViewerAutoLoad.page = 1;
              this.pdfViewerAutoLoad.refresh();
            }
          }, 1000)
      this.ShowSpinner = false
      this.enableNavigation()
      })
  }

  ifCCorBCCSOFA: boolean = false;

  SOFAformmailtoCC() {
    debugger
    this.ifCCorBCCSOFA = !this.ifCCorBCCSOFA;
    if (!this.ifCCorBCCSOFA) {
      this.SOFAform.controls['cc'].reset();
      this.SOFAform.controls['bcc'].reset();
    }
  }

  sendMailTemplate(emailtemplate: any) {
    this.RetriveEmailConfig(emailtemplate)
  }


  sendmail() {
    if (this.SOFAform.valid) {
      this.apiservice.sentmail(this.SOFAform.getRawValue()).subscribe((Data: any) => {
        debugger
        debugger
        var reponse = Data;
        if (reponse == "SOFAEmailResponse") {
          Swal.fire({
            html: '<h5 class="f-s-16 f-w-600 text-black" id="exampleModalLiveLabel">Mail Server details not configured!</h5> <p class= "f-s-14 p-0 m-y-5 f-w-400 text-black"  style="line-height:22px"> Please configure Mail Server setting to send an email.',
            iconHtml: '<span class="fa fa-exclamation rounded-icon"></span>',
            confirmButtonText: "OK",

            allowOutsideClick: false
          }).then((result) => {
            if (result.value) {
            } else {
              return
            }
          })
        }
        else if (reponse == "SOFATemplateresponse") {
          Swal.fire({
            html: '<h5 class="f-s-16 f-w-600 text-black" id="exampleModalLiveLabel">Please complete the Preference</h5> <p class= "f-s-14 p-0 m-y-5 f-w-400 text-black"  style="line-height:22px"> Preference need to be done.',
            iconHtml: '<span class="fa fa-exclamation rounded-icon"></span>',
            confirmButtonText: "OK",
            allowOutsideClick: false
          }).then((result) => {
            if (result.value) {
            } else {
              return
            }
          })
        } else if (reponse == "mail_sent") {
          debugger
          this.dialog.closeAll()
          this.msgService.showToastMessage("success", "Mail sent successfully");
        }
      })
    } else {
      this.SOFAform.markAllAsTouched()


    }
  }
  cenceltemplete() {

    if (this.SOFAform.dirty) {
      Swal.fire({
        html: '<h5 class="f-s-16 f-w-600 text-black" id="exampleModalLiveLabel">Leave the page?</h5> <p class= "f-s-14 p-0 m-y-5 f-w-400 text-black"  style="line-height:22px"> Are you sure you want to leave this page. <br> Data entered will not be saved.</p>',
        iconHtml: '<span class="fa fa-exclamation rounded-icon"></span>',
        confirmButtonText: "Leave",
        showCancelButton: true,
        cancelButtonText: "Stay",
        allowOutsideClick: false,
        reverseButtons: true
      }).then((result) => {
        if (result.isConfirmed) {
          this.SOFAform.markAsUntouched()
          this.SOFAform.markAsPristine()
          this.SOFAform.controls['to'].markAsUntouched()
          this.dialog.closeAll()
        }
        else {
          localStorage.setItem("currentCharityIDFromSwitch", "");
          return
        }

      })

    }
    else {
      this.SOFAform.markAsUntouched()
      this.SOFAform.markAsPristine()
      this.SOFAform.controls['to'].markAsUntouched()
      this.dialog.closeAll()

    }

  }
  isBodyEmpty(formname?: any): boolean {
    const rawHtml = formname.get('Body')?.value || '';
    const strippedText = rawHtml.replace(/<[^>]*>/g, '').trim();
    return strippedText === '';
  }
  exportForm: FormGroup
  Getbasicinformation() {
    debugger

    const period = localStorage.getItem('currentPeriod');
    const charityId = localStorage.getItem('currentCharityID');
    this.Charities_Service.Getbasicinfo(charityId, period).subscribe((data: any) => {
      debugger
      this.BasicInformation = data
      //this.ispreview = this.BasicInformation[0].istrialbalanceaSaved == 1 ? true:fals

    })
  }

  CreateCheckboxform() {
    this.exportForm = new FormGroup({
      coverPage: new FormControl(false),
      contentsPage: new FormControl(false),
      referenceandAdministrationDetails: new FormControl(false),
      trusteesAnnualReport: new FormControl(false),
      statementofTrusteesResponsibility: new FormControl(false),
      independentExaminersReport: new FormControl(false),
      auditorsReport: new FormControl(false),
      statementOfFinancialActivities: new FormControl(true),
      balanceSheet: new FormControl(false),
      notes: new FormControl(false),
      is_ForSubmissions: new FormControl(false),  //important thing this will depend on submissions
      export_Type: new FormControl(null)
    });
  }
  ExportasPDFandIXBRL(ExportType?: any, Is_PDFviwer?: any, template?: any) {
    debugger
    this.ShowSpinner = true;
    this.exportForm.controls["is_ForSubmissions"].setValue(false);
    this.exportForm.controls["export_Type"].setValue(ExportType);
    let Selectedcheckboxes = this.exportForm.value
    const formData: FormData = new FormData();
    // Append checkbox selections as JSON string
    formData.append('SelectedData', JSON.stringify(Selectedcheckboxes));
    formData.append('CompanyRegistrationNumber', this.CharityDetails[0].charity_Registration_Number);
    formData.append('CompanyName', this.CharityDetails[0].charity_Name);
    formData.append('APPeriodCoveredTo', '01/07/2024'); // date as string
    formData.append('ContactName', this.CharityDetails[0].first_Name_Detail);
    formData.append('ContactNumber', this.CharityDetails[0].telephone_Number);
    formData.append('CharityReferenceNumber', this.CharityDetails[0].company_Reference_Number);

    formData.append('APPeriodId', localStorage.getItem("currentPeriodIDForSubmissions") || '');
    formData.append('CompanyID', this.CharityDetails[0].charityID);

    const userId = parseInt(localStorage.getItem('userID') || '0', 10);
    formData.append('UserID', userId.toString());

    // Optional fields - pass empty string to avoid null binding issues
    formData.append('Actiontype', '');
    formData.append('AccountTemplateId', '123456'); // optional int
    formData.append('PackageReference', '');
    formData.append('submissionDate', '');
    formData.append('DateSigned', '');

    // Optional fields not in original post, but required by model
    formData.append('version', '');
    formData.append('submissionstatus', '');
    formData.append('TransactionID', '');
    formData.append('Flag', '');
    formData.append('FBI_URLToUpload', '');
    formData.append('FBI_XMLToUpload', '');
    formData.append('FBIStatus', '');
    formData.append('SaveCredentials', '');
    formData.append('FBI_Master_ID', '');
    formData.append('FBI_History_ID', '');
    formData.append('RequestType', '');
    formData.append('URL', '');
    formData.append('ResponseType', '');
    formData.append('ResponseTimeStamp', '');
    formData.append('ResponseText', '');
    formData.append('PeriodEnd', '');
    formData.append('FBI_History_JSON', '');
    formData.append('FBI_History_JSON_ResponseText', '');
    formData.append('CreatedBy', '');
    formData.append('TaxYear', '');
    formData.append('FBIResponce', '');
    formData.append('APPeriodCoveredFrom', '');
    formData.append('CreatedDate', '');
    this.Submissionsapiservice.GetSelectedReports(formData).subscribe(async (data) => {
      debugger
      if (data) {
        debugger
        this.ShowSpinner = false;
        var parsedData = JSON.parse(data)
        var Base64 = parsedData["base64string"]
        this.Base64orHTML = Base64.xmldata

        if (Is_PDFviwer == 'ForPDFviwer') {
          this.dialog.open(template, { width: '50%', maxWidth: '100%', disableClose: true }); //For opening PDFviewer

          const byteCharacters = atob(this.Base64orHTML);
          const byteNumbers = new Array(byteCharacters.length);

          for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
          }
          const byteArray = new Uint8Array(byteNumbers);
          const blob = new Blob([byteArray], { type: 'application/pdf' });
          var vamshi = URL.createObjectURL(blob);

          setTimeout(() => {
            // Only access pdfViewerAutoLoad if printing
            if (this.pdfViewerAutoLoad) {
              this.pdfViewerAutoLoad.pdfSrc = vamshi;
              this.pdfViewerAutoLoad.downloadFileName = 'Submissions_Report';
              this.pdfViewerAutoLoad.refresh();
            }
          }, 1000);
        } else {
          if (ExportType == 'ExportasPDF') {
            // Convert base64 string to byte array
            const byteCharacters = atob(this.Base64orHTML);
            const byteNumbers = new Array(byteCharacters.length);
            for (let i = 0; i < byteCharacters.length; i++) {
              byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
            const byteArray = new Uint8Array(byteNumbers);
            const blob = new Blob([byteArray], { type: 'application/pdf' });
            const link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = 'Submission_Report.pdf';
            link.click();
            // Optional: clean up
            window.URL.revokeObjectURL(link.href);
          }
          else {
            var blob = new Blob([this.Base64orHTML], { type: "text/html" });
            var url = window.URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;
            link.download = "Submission_XML.html";
            link.click();
          }
        }
      }
    })
  }

  UnlockandAmend() {
    debugger
    var fid: any = localStorage.getItem('currentPeriod') ? localStorage.getItem('currentPeriod') : 0
    if (this.UserRoleAccess.m1Amend) {
      Swal.fire({
        html: `<h5 class="f-s-16 f-w-600 text-black" id="exampleModalLiveLabel">Are you sure?</h5> <p class= "f-s-14 p-0 m-y-5 f-w-400 text-black" style="line-height:22px; padding-right: 30px !important;"> Unlocking the accounting period will allow you to amend the filed accounts and correct any errors. After making any changes, the accounts must be submitted again as an Amended filing. Do you want to unlock and amend the accounting period?</p>`,
        iconHtml: '<span class="fa fa-exclamation rounded-icon"></span>',
        confirmButtonText: "Yes",
        showCancelButton: true,
        cancelButtonText: "No",
        allowOutsideClick: false,
        reverseButtons: true
      }).then((result) => {
        if (result.value) {
          this._UsermanagementService.UnfreezeAP(+fid).subscribe((data: any) => {
            debugger
            this.sharedService.setFinalStatus('InCompleted');
            localStorage.setItem('apFinalised', 'InCompleted')
            localStorage.setItem('NewAmendCycle', 'true');
          })
          //this.save("FinaliseandClose");
        }
        else { }
      })
    }
    else {
      Swal.fire({
        html: '<p class= "f-s-14 p-0 m-y-5 f-w-400 text-black" style="line-height:22px"><b>Access Denied</b> <br/> You do not have the required permissions to perform this action</p>',
        iconHtml: '<span class="fa fa-warning"></span>',
        confirmButtonText: "OK",
        allowOutsideClick: false
      })
    }
  }
  UnfreezeAP() {
    debugger
    var fid: any = localStorage.getItem('currentPeriod') ? localStorage.getItem('currentPeriod') : 0
    if (this.UserRoleAccess.m1Submit) {
      Swal.fire({
        html: `<h5 class="f-s-16 f-w-600 text-black" id="exampleModalLiveLabel">Are you sure?</h5> <p class= "f-s-14 p-0 m-y-5 f-w-400 text-black" style="line-height:22px; padding-right: 30px !important;"> Do you want to unlock the Accounting Period? </p>`,
        iconHtml: '<span class="fa fa-exclamation rounded-icon"></span>',
        confirmButtonText: "Yes",
        showCancelButton: true,
        cancelButtonText: "No",
        allowOutsideClick: false,
        reverseButtons: true
      }).then((result) => {
        if (result.value) {
          this._UsermanagementService.UnfreezeAP(+fid).subscribe((data: any) => {
            debugger
            const message = "Accounting Period unlocked successfully";
            this.msgService.showToastMessage('success', message)
            this.sharedService.setFinalStatus('InCompleted');
            localStorage.setItem('apFinalised', 'InCompleted')
          })
        }
      })
    } else {
      Swal.fire({
        html: '<p class= "f-s-14 p-0 m-y-5 f-w-400 text-black"  style="line-height:22px"> <b>Access Denied</b> <br/> You do not have the required permissions to perform this action</p>',
        iconHtml: '<span class="fa fa-warning"></span>',
        confirmButtonText: "OK",
        allowOutsideClick: false
      })
    }
  }
  gotoSubmissions() {
    var fid: any = localStorage.getItem('currentPeriod') ? localStorage.getItem('currentPeriod') : 0
    if (this.UserRoleAccess.m1Submit) {
      this._UsermanagementService.GoToSubmissions()
    } else {
      Swal.fire({
        html: '<p class= "f-s-14 p-0 m-y-5 f-w-400 text-black"  style="line-height:22px"> <b>Access Denied</b> <br/> You do not have the required permissions to perform this action</p>',
        iconHtml: '<span class="fa fa-warning"></span>',
        confirmButtonText: "OK",
        allowOutsideClick: false
      })
    }

  }

}
export interface Transaction {
  item: string;
  Unrestrictedfunds: number;
  cost: string;
  restrictedfunds: number;
  end: number; total: number; pyf: number;
  type: any;
}
